import styled from 'styled-components';
import { rem } from 'polished';
import colors from '../utils/colors';
import {media} from '../utils/uiSizes';

const WrapperContent = styled.div`
	max-width: ${rem('940px')};
	margin: 0 auto;
	text-align: center;
`;

const WrapperPageContent = styled.div`
	margin: 0 auto;
	padding: 1rem 0 2rem 0;
	${media.tablet`
		padding: 1.5rem 0 2rem 0;
	`}
	${media.desktop`
		padding: 2rem 0 ${rem('80px')};
	`}
	text-align: center;
`;

const WrapperPageArticle = styled.div`
	width: 100%;
	max-width: ${rem('940px')};
	margin: 0 auto;
	box-sizing: border-box;
	padding: ${rem('20px')};
	${media.tablet`
		padding: ${rem('40px')} ${rem('45px')};
	`}
	${media.desktop`
		padding: ${rem('60px')} ${rem('70px')};
	`}

	background: ${colors.WHITE};
	box-shadow: 1px 3px 10px 0 rgba(0,0,0,0.20);
	border-radius: ${rem('5px')};
	text-align: left;

	figure {
		text-align: center;
	}

	.video {
		position:relative;
		display: block;

		&:after {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background-image: url('img/icon-play.png') 0 0 no-repeat;
			background-size: cover;
		}
	}

	a {
		display: block;
		margin: ${rem('20px')} auto;

		&.back {
			margin: 0 auto ${rem('20px')} auto;
			${media.tablet`
				margin-top: ${rem('-20px')};
			`}
		}
	}

	.text {
		padding: 0 ${rem('20px')};
	}

	h4 {
		padding-top: ${rem('10px')};
	}

	h6, p {
		padding-top: ${rem('20px')};
	}

	h6 {
		text-transform: uppercase;
		color: ${colors.GRAY};
	}

	.intro {
		text-align: center;
		font-size: ${rem('22px')};
		//font-style: italic;
		font-family: FyranSans-Core;
		text-align: center;
		padding: ${rem('40px')} 0;
		color: ${colors.GRAY_MIDDLE};
	}
`;

const WrapperPageContentNarrow = styled.div`
	max-width: ${rem('580px')};
	margin: 0 auto;
	text-align: center;
`;

const PageContent = styled.div`
	text-align: left;
`;

export {
	PageContent,
	WrapperContent,
	WrapperPageContent,
	WrapperPageArticle,
	WrapperPageContentNarrow
};



// WEBPACK FOOTER //
// ./src/ui/PageContentWrappers.js